import { createFileRoute } from "@tanstack/react-router";
import { ProductPage } from "../components/shop/product-page.tsx";

export const Route = createFileRoute("/butik/$productSlug")({ component: Screen });

function Screen() {
  const { productSlug } = Route.useParams();
  return <ProductPage productSlug={productSlug} />;
}
